// src/layouts/AuthLayout.jsx
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

import { isAuthenticated } from "../../utils/authStore";

export default function AuthLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If user is already authenticated, redirect to dashboard
    if (isAuthenticated()) {
      // Get the intended destination from location state, or default to dashboard
      const from = location.state?.from?.pathname || "/patient/dashboard";
      navigate(from, { replace: true });
    }
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-bg text-text">
      <div className="mx-auto flex min-h-screen items-center justify-center 
      ">
        <Outlet />
      </div>
    </div>
  );
}